<script>
  import { getContext } from 'svelte';
  import { format } from 'svelte-i18n';
  import { link, useNavigate } from 'svelte-navigator';

  import { Icon } from '@client/components/icon';

  import { PLUGIN_BADGES } from '@client/enums';

  export let row = {};

  const navigate = useNavigate();
  const { basepath } = getContext('config');

  const getBadgeConfig = (type) => {
    return PLUGIN_BADGES[type] || { label: type };
  };
</script>

{#key row.rulename}
  <div class="banner" on:click={() => navigate(`/marketing/campaigns/${row.rulename}`)} role="button" tabindex="0">
    {#if row.adtype === 'image'}
      <img src={row.previewURL} alt={row.filename} loading="lazy" />
    {/if}

    {#if row.adtype === 'text'}
      <div class="text">
        {row.textstring}
      </div>
    {/if}
  </div>
{/key}

{#if row?.targetingSources?.integrations?.campaigns?.length}
  <div class="integrations">
    {#each row.targetingSources.integrations.campaigns as campaign}
      <a use:link href="{basepath}/manage/integrations/{campaign.rulename}" class="btn btn-secondary btn-sm">
        <Icon name="box" />
        {$format(getBadgeConfig(campaign.provider).label)}
      </a>
    {/each}
  </div>
{/if}

<style lang="scss">
  .banner {
    background-color: var(--color-white);
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius-base);
    cursor: pointer;
    max-width: 250px;
    padding: var(--padding-small);
    position: relative;
    user-select: none;

    img {
      display: block;
      height: auto;
      min-height: 40px;
      width: 240px;
    }

    .text {
      padding: var(--padding-base);
    }
  }

  .integrations {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin: calc(var(--margin-base) + 2px) 0;

    a:hover {
      background: var(--color-white);
      border: 1px solid var(--color-gray-400);
      box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.075);
    }
  }
</style>
